<template>
  <help-search />
  <v-list-group
    v-for="group in visibleHelpMenu()"
    :key="group.value"
    :value="group.value"
  >
    <template #activator="{ props }">
      <v-list-item
        min-height="35px"
        v-bind="props"
        :title="titleText(group.title)"
        @click="setRailModeOff"
      >
        <template #prepend>
          <v-icon
            :icon="group.icon"
            size="x-small"
          />
        </template>
      </v-list-item>
    </template>
    <template
      v-for="section in group.sections"
      :key="section.titleKey"
    >
      <v-list-subheader
        class="text-body-large bg-primary-darken-1 opacity-60"
        color="white"
        :title="t(section.titleKey)"
        @click="setRailModeOff"
      />
      <menu-item
        v-for="item in section.items"
        :key="item.to"
        :to="item.to"
        :title="titleText(item.title ?? resolveHelpTitle(item.page))"
        @click="setRailModeOff"
      />
    </template>
  </v-list-group>
  <menu-item
    to="/docs/glossary"
    prepend-icon="fas fa-book"
    :title="t('glossary.title')"
  />
</template>

<script setup lang="ts">
import type { HelpTitle } from '@/help/helpPages';
import { useI18n } from 'vue-i18n';
import { useHelpPages, useMenu } from '@/composables';
import { translateHelpTitle } from '@/help/helpPages';
import HelpSearch from './HelpSearch.vue';
import MenuItem from './MenuItem.vue';

const { visibleHelpMenu, resolveHelpTitle } = useHelpPages();
const { setRailModeOff } = useMenu();

const { t } = useI18n();

const titleText = (title: HelpTitle): string => translateHelpTitle(title, t);
</script>

<style scoped>
.v-list-item {
  --indent-padding: 8px;
}
.v-list-subheader {
  --indent-padding: 20px;

}
</style>
